import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import LoadingSite from "./components/LoadingSite";
import Labels from "./pages/Labels";
import Label from "./pages/Label";
import { CONFIG } from "./config";

// Lazy load route components for code splitting
const Devices = lazy(() => import("./pages/Devices"));
const Account = lazy(() => import("./pages/Account"));
const Device = lazy(() => import("./pages/Device"));
const Contacts = lazy(() => import("./pages/Contacts"));
const Geofences = lazy(() => import("./pages/Geofences"));
const GeofenceForm = lazy(() => import("./pages/GeofenceForm"));
const GeofenceDetail = lazy(() => import("./pages/GeofenceDetail"));
const Share = lazy(() => import("./pages/Share"));
const AuthError = lazy(() => import("./pages/AuthError"));
const Actions = lazy(() => import("./pages/Actions"));
const Organisations = lazy(() => import("./pages/Organisations"));
const OrganisationMembers = lazy(() => import("./pages/OrganisationMembers"));
const LimitReached = lazy(() => import("./pages/LimitReached"));
const RegisterCard = lazy(() => import("./pages/RegisterCard"));
const PaymentSuccess = lazy(() => import("./pages/PaymentSuccess"));
const SubscriptionSuccess = lazy(() => import("./pages/SubscriptionSuccess"));
const NotFound = lazy(() => import("./pages/NotFound"));
const ActionLogs = lazy(() => import("./pages/ActionLogs"));
const CommandInterface = lazy(() => import("./pages/CommandBuilder"));
const OrganisationLogs = lazy(() => import("./pages/OrganisationLogs"));
const AllAlerts = lazy(() => import("./pages/Alerts"));
const Dashboards = lazy(() => import("./pages/Dashboards"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const DashboardSharePage = lazy(() => import("./pages/DashboardShare"));
const Reports = lazy(() => import("./pages/Reports"));
const Report = lazy(() => import("./pages/Report"));
const Assets = lazy(() => import("./pages/Assets"));
const Asset = lazy(() => import("./pages/Asset"));
const TripRegistry = lazy(() => import("./pages/TripRegistry"));
const TripRegistryDevice = lazy(() => import("./pages/TripRegistryDevice"));
const TripRegistryExport = lazy(() => import("./pages/TripRegistryExport"));
const TripRegistryBusinessHours = lazy(
  () => import("./pages/TripRegistryBusinessHours")
);

export default function AppRoutes(props) {
  return (
    <Suspense fallback={<LoadingSite />}>
      <Routes>
        <Route path="/" exact element={<Home />} />
        <Route path="/alerts" exact element={<AllAlerts />} />
        <Route
          path="/account"
          exact
          element={<Account handleThemeChange={props.handleThemeChange} />}
        />
        <Route
          path={"/device"}
          element={<Devices />}
          collapsed={props.collapsed}
        />
        <Route
          path={"/device/:id"}
          element={<Device collapsed={props.collapsed} />}
        />
        <Route path="/contact" element={<Contacts />} />
        <Route path="/geofence" element={<Geofences />} />
        <Route path="/geofence/add" element={<GeofenceForm />} />
        <Route path="/geofence/:id/view" element={<GeofenceDetail />} />
        <Route path="/geofence/:id" element={<GeofenceForm />} />
        <Route path="/share/:id" element={<Share />} />
        <Route
          path="/share/dashboard/:id"
          element={
            <DashboardSharePage handleThemeChange={props.handleThemeChange} />
          }
        />
        <Route path="/auth-error" element={<AuthError />} />
        <Route path="/action" element={<Actions />} />
        <Route path="/action/:id/logs" element={<ActionLogs />} />
        <Route path="/organisation" element={<Organisations />} />
        <Route
          path="/organisation/:id/members"
          element={<OrganisationMembers />}
        />
        <Route path="/organisation/:id/logs" element={<OrganisationLogs />} />
        <Route path="/billing/limit-reached" element={<LimitReached />} />
        <Route path="/billing/register-card" element={<RegisterCard />} />
        <Route path="/billing/success" element={<PaymentSuccess />} />
        <Route
          path="/billing/subscription-success"
          element={<SubscriptionSuccess />}
        />
        <Route path="*" element={<NotFound />} />
        <Route path="/command" element={<CommandInterface />} />
        <Route path="/dashboard" element={<Dashboards />} />
        <Route
          path="/dashboard/:id"
          element={<Dashboard collapsed={props.collapsed} />}
        />
        <Route path="/report" element={<Reports />} />
        <Route path="/report/:id" element={<Report />} />
        <Route path="/asset" element={<Assets />} />
        <Route path="/asset/:id" element={<Asset />} />
        <Route path="/home" element={<Home />} />

        <Route path="/label" element={<Labels />} />
        <Route path="/label/:id" element={<Label />} />

        {CONFIG.trip_registry_enabled && (
          <>
            <Route path="/trips" element={<TripRegistry />} />
            <Route path="/trips/export" element={<TripRegistryExport />} />
            <Route
              path="/trips/business-hours"
              element={<TripRegistryBusinessHours />}
            />
            <Route path="/trips/:deviceId" element={<TripRegistryDevice />} />
          </>
        )}
      </Routes>
    </Suspense>
  );
}
